<template>
  <div class="doge-shell">
    <header class="doge-top"><button class="doge-back" @click="$router.back()">‹</button><h1 class="doge-title">账户安全</h1><div class="doge-placeholder"></div></header>
    <main class="doge-page-pad">
      <section class="setting-user"><img src="@/assets/img/user-avatar.png"><div><h2>{{ masked }}</h2><p>DOGE生态账户</p></div></section>
      <section class="doge-card">
        <div class="setting-row"><span>头像</span><img src="@/assets/img/user-avatar.png"></div>
        <div class="setting-row"><span>昵称</span><b>{{ nickname }}</b></div>
        <div class="setting-row"><span>登录钱包</span><b>{{ masked }}</b></div>
      </section>
      <section v-if="showEmail" class="pwd-modal">
        <div class="pwd-sheet">
          <button class="close" @click="showEmail=false">×</button>
          <h3>绑定邮箱</h3>
          <p class="hint">首次请先输入邮箱，并使用邮箱验证码完成绑定。</p>
          <input v-model="bindEmail" type="email" placeholder="请输入邮箱地址">
          <div class="code-row">
            <input v-model="emailCode" inputmode="numeric" placeholder="请输入邮箱验证码">
            <button :disabled="sendingEmailCode || emailCountdown > 0 || !bindEmail" @click="sendBindEmailCode">{{ emailCodeButtonText }}</button>
          </div>
          <button class="doge-btn full" :disabled="bindingEmail" @click="bindEmailAccount">{{ bindingEmail ? '绑定中...' : '确认绑定' }}</button>
        </div>
      </section>
      <section v-if="showPwd" class="pwd-modal">
        <div class="pwd-sheet">
          <button class="close" @click="showPwd=false">×</button>
          <h3>{{ hasPwd ? '修改支付密码' : '设置支付密码' }}</h3>
          <p class="hint">验证码将发送到账户绑定邮箱，用于确认本人操作。</p>
          <div class="contact-box">
            <span>接收账号</span>
            <b>{{ contactLabel }}</b>
          </div>
          <div class="code-row">
            <input v-model="authCode" inputmode="numeric" placeholder="请输入验证码">
            <button :disabled="sendingCode || countdown > 0 || !contactTarget" @click="sendCode">{{ codeButtonText }}</button>
          </div>
          <input v-model="newPwd" type="password" placeholder="请输入6-16位新支付密码">
          <button class="doge-btn full" :disabled="submitting" @click="savePwd">{{ submitting ? '提交中...' : '确认' }}</button>
        </div>
      </section>
    </main>
    <BottomNav/>
  </div>
</template>
<script>
import BottomNav from '../../components/layout/BottomNav.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'setting',
  components: { BottomNav },
  data() { return { showPwd: false, showEmail: false, bindEmail: '', emailCode: '', bindingEmail: false, sendingEmailCode: false, emailCountdown: 0, authCode: '', newPwd: '', submitting: false, sendingCode: false, countdown: 0, timer: null, emailTimer: null }; },
  computed: {
    ...mapGetters(['getUserDetails', 'getWalletAddress']),
    user() { return this.getUserDetails || {}; },
    masked() { const s = (this.getWalletAddress || '00***').toString(); return s.length > 10 ? s.slice(0, 6) + '...' + s.slice(-4) : s; },
    nickname() { return (this.user.nickname || this.user.account) || this.masked; },
    hasPwd() { return !!(this.user.pay_password || this.user.has_pay_password || this.user.payPasswordSet); },
    mobile() { return this.user.mobile || this.user.phone || ''; },
    email() { return this.user.email || ''; },
    areaId() { return this.user.area_id || this.user.areaId || 1; },
    contactType() { return this.email ? 'email' : ''; },
    contactTarget() { return this.email || ''; },
    contactLabel() {
      if (this.email) return this.maskEmail(this.email) + '（邮箱）';
      return '当前未绑定邮箱';
    },
    emailCodeButtonText() { if (this.emailCountdown > 0) return this.emailCountdown + '秒后重发'; return this.sendingEmailCode ? '发送中...' : '发送验证码'; },
    codeButtonText() {
      if (this.countdown > 0) return this.countdown + '秒后重发';
      return this.sendingCode ? '发送中...' : '发送验证码';
    }
  },
  beforeDestroy() { if (this.timer) clearInterval(this.timer); if (this.emailTimer) clearInterval(this.emailTimer); },
  methods: {
    openPwd() {
      this.showPwd = true;
      if (!this.contactTarget) { this.showPwd = false; this.showEmail = true; this.msg('请绑定邮箱，设置支付密码', 'error'); }
    },
    async sendBindEmailCode() {
      if (!this.bindEmail) return this.msg('请先输入邮箱');
      this.sendingEmailCode = true;
      try {
        const r = await this.$axios.post('/api/notify/send_email', { to: this.bindEmail, area_id: this.areaId, type: 6 });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg || '验证码发送失败，请稍后再试');
        this.msg('验证码已发送', 'success');
        this.emailCountdown = 60;
        if (this.emailTimer) clearInterval(this.emailTimer);
        this.emailTimer = setInterval(() => { this.emailCountdown -= 1; if (this.emailCountdown <= 0) { clearInterval(this.emailTimer); this.emailTimer = null; } }, 1000);
      } catch (e) { this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '验证码发送失败，请稍后再试', 'error'); }
      finally { this.sendingEmailCode = false; }
    },
    async bindEmailAccount() {
      if (!this.bindEmail || !this.emailCode) return this.msg('请填写邮箱和验证码');
      this.bindingEmail = true;
      try {
        const r = await this.$axios.post('/api/user/bind_account', { type: 'email', account: this.bindEmail, auth_code: this.emailCode });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg || '绑定失败');
        this.msg('邮箱绑定成功', 'success');
        this.showEmail = false; this.bindEmail = ''; this.emailCode = '';
        await this.$store.dispatch('fetchUserDetails');
      } catch (e) { this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '绑定失败', 'error'); }
      finally { this.bindingEmail = false; }
    },
    async sendCode() {
      if (!this.contactTarget) return this.msg('当前未绑定邮箱，无法发送验证码', 'error');
      this.sendingCode = true;
      try {
        const r = await this.$axios.post('/api/notify/send_email', { to: this.email, area_id: this.areaId, type: 3 });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg || '验证码发送失败，请稍后再试');
        this.msg('验证码已发送', 'success');
        this.startCountdown();
      } catch (e) {
        this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '验证码发送失败，请稍后再试', 'error');
      } finally {
        this.sendingCode = false;
      }
    },
    startCountdown() {
      this.countdown = 60;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) { clearInterval(this.timer); this.timer = null; }
      }, 1000);
    },
    async savePwd() {
      if (!this.authCode || !this.newPwd) return this.msg('请填写验证码和新的支付密码');
      if (this.newPwd.length < 6 || this.newPwd.length > 16) return this.msg('密码只能在6-16位之间');
      this.submitting = true;
      try {
        const r = await this.$axios.post('/api/user/amend_pay_password', { auth_code: this.authCode, password: this.newPwd });
        if (![1, 200].includes(Number(r.data.code))) throw new Error(r.data.message || r.data.msg || '没有保存成功，请稍后再试');
        this.msg('支付密码已设置', 'success');
        this.showPwd = false;
        this.authCode = '';
        this.newPwd = '';
        this.$store.dispatch('fetchUserDetails');
      } catch (e) {
        this.msg((e.response && e.response.data && (e.response.data.message || e.response.data.msg)) || e.message || '没有保存成功，请稍后再试', 'error');
      } finally {
        this.submitting = false;
      }
    },
    maskContact(v) { v = (v || '').toString(); return v.length > 7 ? v.slice(0, 3) + '****' + v.slice(-4) : v; },
    maskEmail(v) { v = (v || '').toString(); const arr = v.split('@'); return arr.length === 2 ? arr[0].slice(0, 2) + '***@' + arr[1] : v; },
    msg(t, type = 'info') { this.$messageDialog ? this.$messageDialog.alert(t, '提示', type) : alert(t); }
  }
};
</script>
<style scoped>.setting-user{display:flex;align-items:center;gap:14px;border-radius:20px;background:linear-gradient(160deg,#d89a2e,#f0d37c);padding:18px;margin-bottom:16px;box-shadow:0 6px 18px rgba(75,52,0,.10)}.setting-user img{width:66px;height:66px;border-radius:50%;border:3px solid #fff}.setting-user h2{margin:0;color:#fff}.setting-user p{margin:6px 0 0;color:#fff7df}.setting-row{min-height:58px;border-bottom:1px solid var(--doge-line);display:flex;align-items:center;justify-content:space-between;gap:12px}.setting-row:last-child{border-bottom:0}.setting-row span{color:#211507}.setting-row b{font-size:14px;color:#8b806d;text-align:right}.setting-row img{width:42px;height:42px;border-radius:50%}.setting-row button{border:0;border-radius:999px;background:var(--doge-primary);color:#fff;padding:8px 14px;font-weight:700}.pwd-modal{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:2200;display:flex;align-items:flex-end}.pwd-sheet{position:relative;width:100%;background:#fff;border-radius:24px 24px 0 0;padding:28px 18px}.pwd-sheet h3{text-align:center;margin:0 0 12px;color:#211507}.hint{color:#8b806d;line-height:1.6;font-size:13px;margin:0 0 14px}.pwd-sheet input{width:100%;height:48px;border:1px solid #ead9b6;border-radius:14px;background:#fff;color:#211507;padding:0 14px;margin-bottom:12px}.close{position:absolute;right:18px;top:14px;width:32px;height:32px;border:0;border-radius:50%;background:var(--doge-primary);color:#fff;font-size:22px}.contact-box{display:flex;justify-content:space-between;gap:12px;background:#fff8e8;border-radius:12px;padding:12px;margin-bottom:12px;color:#8b806d;font-size:13px}.contact-box b{color:#211507;text-align:right}.code-row{display:flex;gap:10px}.code-row input{flex:1}.code-row button{width:112px;height:48px;border:0;border-radius:14px;background:var(--doge-primary);color:#fff;font-weight:700}.code-row button:disabled{opacity:.55}</style>
